import PropTypes from 'prop-types';

const iconShape = PropTypes.shape({
  icon: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string), // Ligatures (deprecated; usually empty).
      PropTypes.number, // Height and width.
      PropTypes.string, // Unicode and SVG path data.
    ])
  ).isRequired,
  iconName: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
});

export default iconShape;
